import { render, staticRenderFns } from "./planet-activation-watch.vue?vue&type=template&id=527c32ca&"
import script from "./planet-activation-watch.vue?vue&type=script&lang=js&"
export * from "./planet-activation-watch.vue?vue&type=script&lang=js&"
import style0 from "./planet-activation-watch.vue?vue&type=style&index=0&id=527c32ca&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports